import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, FormGroup, FormText, Input, Label, Row, FormFeedback, InputGroupAddon, InputGroup } from 'reactstrap';

import { ConfirmCurrentPasswordModal } from './ConfirmCurrentPasswordModal';
import defaultAvatar from '../../../assets/img/default-avatar.svg';
import avatar_file from '../../../assets/img/edit-avatar.svg';

export const EditForm = ({
    inputValues,
    handleInputChange,
    onSubmitUpdateInfo,
    onAvatarChange,
    avatarSrc,
    genericSaveError = '',
    emailChanged = false,
    passwordModalErrorOnly = false,
    closePasswordModalOnValidation = false,
    formErrors,
    formValid,
    lists = [],
    toggleShowForm
}) => {
    const [openConfirmCurrentPasswordModal, setOpenConfirmCurrentPasswordModal] = useState(false);
    const [disabled, setDisabled] = useState(true);

    const toggleConfirmCurrentPasswordModal = () => {
        setOpenConfirmCurrentPasswordModal(!openConfirmCurrentPasswordModal);
    }

    const onSubmit = (e) => {
        e.preventDefault();

        setOpenConfirmCurrentPasswordModal(true);
    }

    const onConfirmCurrentPassword = () => {
        onSubmitUpdateInfo();
    }

    useEffect(() => {
        setDisabled(!formValid());
    }, [inputValues, formErrors, formValid])

    useEffect(() => {
        if (genericSaveError) {
            setOpenConfirmCurrentPasswordModal(false);
        }
    }, [genericSaveError]);

    useEffect(() => {
        if (passwordModalErrorOnly) {
            setOpenConfirmCurrentPasswordModal(true);
        }
    }, [passwordModalErrorOnly]);

    useEffect(() => {
        if (genericSaveError || closePasswordModalOnValidation) {
            setOpenConfirmCurrentPasswordModal(false);
        }
    }, [genericSaveError, closePasswordModalOnValidation]);

    return (
        <>
            <Form onSubmit={onSubmit} >
                <div className='mb-3 d-md-flex'>
                    <div className="pr-3">
                        <FormGroup className='avatar-file d-inline-block'>
                            <img className="user-avatar avatar-object rounded-circle" width="100" height="100" src={avatarSrc || defaultAvatar} alt={inputValues.firstName}/>
                            <span><img src={avatar_file} width={30} height={30} alt='update avatar'/></span>
                            <Input
                                type="file"
                                name="file"
                                id="avatar"
                                accept="image/*"
                                onChange={onAvatarChange}
                            />
                        </FormGroup>
                    </div>
                    <div className='flex-fill'>
                        <Row form className='flex-fill'>
                            <Col xs={6}>
                                <FormGroup>
                                    <Label for="first_name">First Name</Label>
                                    <InputGroup size="lg" className='flex-row-reverse'>
                                        <Input type="text" name="firstName" id="first_name" value={inputValues.firstName} onChange={handleInputChange} valid={formErrors.firstName === ''} className='border-left-0 pl-0'/>
                                        <InputGroupAddon addonType="prepend">
                                        <span className={`input-group-text border-right-0 border-rounded pl-3 pr-2 ${formErrors.firstName === '' ? 'border-green text-green' : 'text-muted'}`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} viewBox="0 0 16 17" fill='currentColor'>
                                            <path d="M14.4,13.8c-0.9-1.6-2.4-2.8-4.1-3.4c0.8-0.5,1.5-1.3,1.9-2.2c0.4-0.9,0.4-1.9,0.2-2.9
                                                c-0.3-0.9-0.8-1.8-1.6-2.4C9.9,2.3,9,2,8,2C7,2,6.1,2.3,5.3,2.9C4.5,3.5,3.9,4.4,3.7,5.3c-0.3,0.9-0.2,2,0.2,2.9
                                                c0.4,0.9,1,1.7,1.9,2.2h0c-1.7,0.6-3.2,1.8-4.1,3.4c0,0.1-0.1,0.2-0.1,0.2s0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2
                                                c0.1,0,0.2,0.1,0.3,0.1h12c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0.1-0.2,0.1-0.2C14.5,13.9,14.5,13.8,14.4,13.8z"/>
                                            </svg>
                                        </span>
                                        </InputGroupAddon>
                                    </InputGroup>
                                    {formErrors.firstName && <FormText>{formErrors.firstName}</FormText>}
                                </FormGroup>
                            </Col>
                            <Col xs={6}>
                                <FormGroup>
                                    <Label for="last_name">Last Name</Label>
                                    <InputGroup size="lg" className='flex-row-reverse'>
                                        <Input type="text" name="lastName" id="last_name" value={inputValues.lastName} onChange={handleInputChange} valid={formErrors.lastName === ''} className='border-left-0 pl-0'/>
                                        <InputGroupAddon addonType="prepend">
                                        <span className={`input-group-text border-right-0 pl-3 pr-2 ${formErrors.lastName === '' ? 'border-green text-green' : 'text-muted'}`}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} viewBox="0 0 16 17" fill='currentColor'>
                                            <path d="M14.4,13.8c-0.9-1.6-2.4-2.8-4.1-3.4c0.8-0.5,1.5-1.3,1.9-2.2c0.4-0.9,0.4-1.9,0.2-2.9
                                                c-0.3-0.9-0.8-1.8-1.6-2.4C9.9,2.3,9,2,8,2C7,2,6.1,2.3,5.3,2.9C4.5,3.5,3.9,4.4,3.7,5.3c-0.3,0.9-0.2,2,0.2,2.9
                                                c0.4,0.9,1,1.7,1.9,2.2h0c-1.7,0.6-3.2,1.8-4.1,3.4c0,0.1-0.1,0.2-0.1,0.2s0,0.2,0.1,0.2c0,0.1,0.1,0.1,0.2,0.2
                                                c0.1,0,0.2,0.1,0.3,0.1h12c0.1,0,0.2,0,0.2-0.1c0.1,0,0.1-0.1,0.2-0.2c0-0.1,0.1-0.2,0.1-0.2C14.5,13.9,14.5,13.8,14.4,13.8z"/>
                                            </svg>
                                        </span>
                                        </InputGroupAddon>
                                    </InputGroup>
                                    {formErrors.lastName && <FormText>{formErrors.lastName}</FormText>}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row className='pb-5'>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="email">Email Address</Label>
                                    <InputGroup size="lg" className='flex-row-reverse'>
                                        <Input type="email" name="email" id="email" value={inputValues.email} onChange={handleInputChange} className='border-left-0 pl-0' valid={(formErrors.email !== '' || inputValues.email === '') ? null : true}/>
                                        <InputGroupAddon addonType="prepend">
                                        <span className={`input-group-text border-right-0 pl-3 pr-2 ${(formErrors.email !== '' || inputValues.email === '') ? 'text-muted' : 'border-green text-green'}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill='currentColor'>
                                        <path d="M17.5,3.7h-15c-0.2,0-0.3,0.1-0.4,0.2C1.9,4.1,1.9,4.2,1.9,4.4V15c0,0.3,0.1,0.6,0.4,0.9
                                            c0.2,0.2,0.6,0.4,0.9,0.4h13.8c0.3,0,0.6-0.1,0.9-0.4c0.2-0.2,0.4-0.6,0.4-0.9V4.4c0-0.2-0.1-0.3-0.2-0.4
                                            C17.8,3.8,17.7,3.7,17.5,3.7z M16.9,15H3.1V5.8l6.5,5.9c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l6.5-5.9V15z"/>
                                        </svg>
                                        </span>
                                        </InputGroupAddon>
                                    </InputGroup>
                                    {formErrors.email && <FormText>{formErrors.email}</FormText>}
                                    <FormText>If you are changing email address, you have to enter again in below field</FormText>
                                </FormGroup>
                            </Col>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="confirm-email">Confirm Email Address</Label>
                                    <InputGroup size="lg" className='flex-row-reverse'>
                                        <Input type="email" name="confirmEmail" id="confirm-email" value={inputValues.confirmEmail}
                                            onChange={handleInputChange} valid={(formErrors.confirmEmail !== '' || inputValues.confirmEmail === '') ? null : true}
                                            className='border-left-0 pl-0' placeholder='Re-Enter Email Address again'/>
                                        <InputGroupAddon addonType="prepend">
                                        <span className={`input-group-text border-right-0 pl-3 pr-2 ${(formErrors.confirmEmail !== '' || inputValues.confirmEmail === '') ? 'text-muted' : 'border-green text-green'}`}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill='currentColor'>
                                        <path d="M17.5,3.7h-15c-0.2,0-0.3,0.1-0.4,0.2C1.9,4.1,1.9,4.2,1.9,4.4V15c0,0.3,0.1,0.6,0.4,0.9
                                            c0.2,0.2,0.6,0.4,0.9,0.4h13.8c0.3,0,0.6-0.1,0.9-0.4c0.2-0.2,0.4-0.6,0.4-0.9V4.4c0-0.2-0.1-0.3-0.2-0.4
                                            C17.8,3.8,17.7,3.7,17.5,3.7z M16.9,15H3.1V5.8l6.5,5.9c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l6.5-5.9V15z"/>
                                        </svg>
                                        </span>
                                        </InputGroupAddon>
                                    </InputGroup>
                                    {formErrors.confirmEmail && <FormText>{formErrors.confirmEmail}</FormText>}
                                </FormGroup>
                            </Col>
                            {lists?.seniorities?.size > 0 &&
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="select">Role / Seniority</Label>
                                    <InputGroup size='lg' className='flex-row-reverse'>
                                        <Input type="select" onChange={handleInputChange} name="seniority" invalid={formErrors.seniority === '' ? null : true} value={inputValues.seniority} className='border-left-0 pl-0'>
                                            <option value="">Select your option</option>
                                            {
                                                lists?.seniorities &&
                                                lists?.seniorities.map(item =>
                                                    <option key={item.id} value={item.id}>{item.name}</option>
                                                )
                                            }
                                        </Input>
                                        <InputGroupAddon addonType="prepend">
                                            <span className={`input-group-text border-right-0 pl-3 pr-2 ${formErrors.seniority === '' ? 'text-muted' : 'border-green text-green'}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill='currentColor'>
                                                <path d="M17.8,4.9l-0.4-0.2c0-0.2,0-0.5,0-0.7l0.4-0.2c0.1-0.1,0.2-0.2,0.3-0.4s0-0.3-0.1-0.5c-0.1-0.1-0.2-0.2-0.4-0.3
                                                    c-0.2,0-0.3,0-0.5,0.1L16.8,3c-0.2-0.1-0.4-0.3-0.6-0.3V2.2c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.4,0.2
                                                    C15.1,1.9,15,2,15,2.2v0.4c-0.2,0.1-0.4,0.2-0.6,0.3L14,2.7c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0.1-0.2,0.1
                                                    c-0.1,0-0.1,0.1-0.2,0.2c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.2L13.8,4
                                                    c0,0.2,0,0.5,0,0.7l-0.4,0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.3,0,0.4c0,0.1,0.1,0.3,0.2,0.3c0.1,0.1,0.2,0.1,0.4,0.1
                                                    c0.1,0,0.2,0,0.3-0.1l0.4-0.2c0.2,0.1,0.4,0.3,0.6,0.3v0.4c0,0.2,0.1,0.3,0.2,0.4c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2
                                                    c0.1-0.1,0.2-0.3,0.2-0.4V6.1c0.2-0.1,0.4-0.2,0.6-0.3L17.2,6c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.2-0.3
                                                    c0-0.1,0-0.3,0-0.4C18,5.1,18,5,17.8,4.9z M15.6,5c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1-0.1-0.2,0-0.4
                                                    c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1,0,0.2,0,0.4,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0.1,0.3
                                                    c0,0.2-0.1,0.3-0.2,0.4C15.9,4.9,15.8,5,15.6,5z M10,5.9c0.7,0,1.3,0.2,1.9,0.6c0.6,0.4,1,0.9,1.3,1.5c0.3,0.6,0.3,1.3,0.2,2
                                                    c-0.1,0.7-0.5,1.3-0.9,1.8c-0.5,0.5-1.1,0.8-1.8,0.9c-0.7,0.1-1.4,0.1-2-0.2c-0.6-0.3-1.2-0.7-1.5-1.3c-0.4-0.6-0.6-1.2-0.6-1.9
                                                    c0-0.9,0.4-1.8,1-2.4S9.1,5.9,10,5.9z M18,8.6c0.3,1.7,0,3.4-0.7,5c-0.8,1.5-2,2.8-3.5,3.6c-1.5,0.8-3.3,1.1-5,0.8
                                                    c-1.7-0.3-3.3-1.1-4.5-2.3c-1.2-1.2-2-2.8-2.3-4.5c-0.3-1.7,0-3.4,0.8-5c0.8-1.5,2-2.8,3.6-3.5c1.5-0.8,3.3-1,5-0.7
                                                    c0.2,0,0.3,0.1,0.4,0.3c0.1,0.1,0.1,0.3,0.1,0.5c0,0.2-0.1,0.3-0.3,0.4c-0.1,0.1-0.3,0.1-0.5,0.1c-1-0.2-2-0.1-3,0.1
                                                    c-1,0.3-1.9,0.7-2.6,1.4C4.8,5.4,4.2,6.2,3.8,7.1C3.3,8,3.1,9,3.1,10c0,1.7,0.6,3.3,1.7,4.6c0.5-0.7,1-1.2,1.7-1.7
                                                    c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1,0,0.2,0.1c0.8,0.7,1.9,1.1,3.1,1.1c1.1,0,2.2-0.4,3.1-1.1c0.1,0,0.1-0.1,0.2-0.1
                                                    c0.1,0,0.1,0,0.2,0.1c0.7,0.4,1.2,1,1.7,1.7c1.1-1.3,1.7-2.9,1.7-4.6c0-0.4,0-0.8-0.1-1.1c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.2,0.1-0.2
                                                    c0-0.1,0.1-0.1,0.2-0.2s0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0s0.2,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.2C18,8.5,18,8.6,18,8.6z"/>
                                                </svg>
                                            </span>
                                        </InputGroupAddon>
                                    </InputGroup>
                                    {formErrors.currentCareerLevel && <FormFeedback>{formErrors.currentCareerLevel}</FormFeedback>}
                                </FormGroup>
                            </Col>
                            }

                            {genericSaveError && (
                                <FormText color='danger' className="ml-3 mb-1">
                                    {genericSaveError}
                                </FormText>
                            )}

                            <div className='botones-perfil d-flex col-12 py-3 py-md-0'>
                                <Button color='green-light' size='sm' type='submit' disabled={disabled} className='flex-fill flex-md-grow-0' >
                                    <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill='currentColor' className='mt-n1 mr-2'>
                                    <path d="M13.2,4.4l-7,7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1
                                        L2.2,8.3C2.2,8.3,2.1,8.2,2.1,8.1C2,8,2,8,2,7.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
                                        c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1L5.7,10l6.5-6.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
                                        c0.1,0.1,0.2,0.3,0.2,0.5C13.4,4.1,13.3,4.3,13.2,4.4L13.2,4.4z"/>
                                    </svg>
                                    Save Changes
                                </Button>
                                <Button color='outline-green-light' size='sm' className='ml-3 flex-fill flex-md-grow-0' onClick={() => toggleShowForm('viewProfile')} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14} viewBox="0 0 15 14" fill='currentColor' className='mt-n1 mr-2'>
                                    <path d="M11.9,10.5c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.3-0.1-0.5-0.2
                                        L7.5,7.9L4,11.4c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.2,0.1-0.3,0.2-0.5L6.6,7L3.1,3.5
                                        C3,3.4,2.9,3.2,2.9,3.1S3,2.7,3.1,2.6c0.1-0.1,0.3-0.2,0.5-0.2S3.9,2.5,4,2.6l3.5,3.5L11,2.6c0.1-0.1,0.3-0.2,0.5-0.2
                                        c0.2,0,0.3,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5S12,3.4,11.9,3.5L8.4,7L11.9,10.5z"/>
                                    </svg>
                                    Discard Changes
                                </Button>
                            </div>

                        </Row>
                    </div>
                </div>

                <ConfirmCurrentPasswordModal isOpen={openConfirmCurrentPasswordModal} toggle={toggleConfirmCurrentPasswordModal} setCurrentPassword={(value) => handleInputChange({ target: { name: 'currentPassword', value } })} error={formErrors.currentPassword || null} onAccept={onConfirmCurrentPassword} />
            </Form>
        </>
    )
}
